import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ObjProfilTypeCred } from '../model/obj-profil-type-cred';

@Injectable({
    providedIn: 'root'
  })
  export class ObjProfilTypeCredService{

    constructor(private _restClientService: RestClientService) {}

    getAllObjProfilTypeCred()
    {
        return this._restClientService.load<ObjProfilTypeCred[]>("objectif-profil-type-credit/obj-profil-type-creds");
    }

    postObjProfilTypeCred(objectif) {
        return this._restClientService.save<ObjProfilTypeCred>('objectif-profil-type-credit/add-obj-profil-type-cred', objectif);
    }

    getObjProfilTypeCredById(id) {
        return this._restClientService.load<ObjProfilTypeCred>("objectif-profil-type-credit/obj-profil-type-cred-by-id/"+id);
    }

    putObjProfilTypeCred(objectif) {
        return this._restClientService.put<ObjProfilTypeCred>(`objectif-profil-type-credit/update-obj-profil-type-cred`, objectif);
    }

    getObjProfilTypeCredsByProfilId(profilid, workflowid){
        return this._restClientService.load<ObjProfilTypeCred[]>("objectif-profil-type-credit/obj-profil-type-creds-by-profilid?profilId="+profilid+"&workflowId="+workflowid);
    }

}      

    